<form class="form-container chat-box-input" [formGroup]="form" (submit)="send()">
  <div class="form__row">
    <div class="form__field input-area">
      <mat-form-field appearance="fill">
        <textarea #inputArea formControlName="text" matInput placeholder="{{'ChatBox.Placeholder' | translate}}"
          maxlength="500"></textarea>
      </mat-form-field>
      <button type="submit" class="btn-send" [disabled]="!canValidate()">
        <img class="icon" src="assets/icons/icon-send.svg" alt="send">
      </button>
    </div>
  </div>
</form>